// src/pages/jury/LoginPage.tsx
import React from 'react';
import JuryLogin from '../../components/jury/JuryLogin';

const JuryLoginPage: React.FC = () => {
  return <JuryLogin />;
};

export default JuryLoginPage;
